const Constants = {
	// Navigators
	navigatorRoot: 'Index',
	navigatorGalleryStack: 'GalleryStack',
	navigatorSettingsStack: 'SettingsStack',
	navigatorTab: 'TabNavigator',

	// Tab screens
	screenHome: 'MainTab',
	screenArchive: 'Archief',
	screenMessages: 'Berichten',
	screenPhotos: 'Fotos',
	screenSettings: 'Instellingen',

	// Gallery stack screens
	screenRootGalleries: 'Fotos',
	screenRootGalleryHolder: 'RootGalleryHolder',
	screenRootGalleryPage: 'RootGalleryPage',

	// Settings stack screens
	screenSettingsRoot: 'Settings',
	screenFeedbackPage: 'FeedbackPage',
	screenContactPage: 'ContactPage',
	screenProfilePage: 'ProfilePage',
	screenProfileRegistrationPage: 'ProfileRegistrationPage',
	screenProfileLoginPage: 'ProfileLoginPage',
	screenLostPasswordPage: 'LostPasswordPage',
	screenUpdatePassword: 'UpdatePassword',

	// Root stack screens
	screenSplash: 'Splash',
	screenIndex: 'Index',
	screenEvent: 'Event',
	screenEventDeeplink: 'EventDeeplink',
	screenProgramHolder: 'ProgramHolder',
	screenTimetableHolder: 'TimetableHolder',
	screenTimetableDay: 'TimetableDay',
	screenProgram: 'Program',
	screenProgramItem: 'ProgramItem',
	screenNewsItemPage: 'NewsItemPage',
	screenFloorplan: 'Floorplan',
	screenFormClosed: 'FormClosed',
	screenFormLogin: 'FormLogin',
	screenCustom: 'Custom',
	screenGalleryHolder: 'GalleryHolder',
	screenGallery: 'Gallery',
	screenLocationItem: 'LocationItem',
	screenFoodItem: 'FoodItem',
	screenNewsItem: 'NewsItem',
	screenTimeTablePage: 'TimeTablePage',
	screenNews: 'News',
	screenLocations: 'Locations',
	screenFood: 'Food',
	screenLogin: 'Login',
	screenLoginForm: 'LoginForm',
	screenRegistrationForm: 'RegistrationForm',
	screenForgotPassword: 'ForgotPassword',
	screenChangePassword: 'ChangePassword',
	screenQrScanner: 'QrScanner',
	screenMySubmission: 'MySubmission',

	// Sentry
	sentryDsn: 'https://349a7a5770401083fdb9030dfe8c07af@o398254.ingest.us.sentry.io/4506993293787136',
	sentryEnvironmentDevelopment: 'development',
	sentryErrorAxios: 'AxiosError',
	sentryBreadcrumbCategoryConsole: 'console',
	sentryEventLevelFatal: 'fatal',
	sentryEventLevelError: 'error',

	// Storage keys
	storageEvents: 'events',
	storageMyTimetable: 'myTimetable',
	storageMyBarTimetable: 'myBarTimetable',
	storageNotificationsRead: 'notificationsRead',
	storageForms: 'forms',
	storageAuthToken: 'authToken',
	storageNews: 'news',
	storageNotificationState: 'NotificationState',
	storageMigrationComplete: 'migrationComplete',
	storageInstallationId: 'installationId',

	// Display date/time formats (dayjs)
	dateFormat: 'DD-MM-YYYY',
	// A day named in words ("23 juni 2026"), for a heading that says which day it covers.
	dayFormat: 'D MMMM YYYY',
	timeFormat: 'HH:mm',

	// API headers (backend uses a custom `token` header, not Bearer)
	apiHeaderToken: 'token',
	apiHeaderContentType: 'Content-Type',
	apiHeaderAccept: 'Accept',
	apiHeaderAcceptLanguage: 'Accept-Language',
	apiHeaderCacheControl: 'Cache-Control',
	apiHeaderPragma: 'Pragma',
	apiHeaderExpires: 'Expires',

	// Auth events
	eventAuthOnUnauthorized: 'auth:onUnauthorized',

	// Event-list events (useEventStore -> useAuthenticationStore account sync, without a store import cycle)
	eventEventsAdded: 'events:added',
	eventEventsRemoved: 'events:removed',

	// API events
	eventApiOnError: 'api:onError',
	eventApiOnSuccess: 'api:onSuccess',

	// Alert events (web: a notice raised from core, queued by the alert-dialog store)
	eventAlertOnRequest: 'alert:onRequest',

	// Secure storage keys (Keychain / Keystore)
	secureStorageAuthToken: 'topev.auth.token',

	// Widest the app renders in a browser: a phone-sized column, centred, with the Topicus grey
	// around it. AppViewport.web reads it through useViewportStore and publishes it to the screens
	// via useContentWidth.
	maxContentWidth: 500,
} as const;

export default Constants;
